import {
  EditorListBadge,
  EditorListItem,
  EditorListItemContent,
  EditorListItemDescription,
  EditorListItemTitle,
} from '@/features/legends/components/EditorList'
import type { MappingType } from '@/features/legends/templates/MappingEditorViewModel'
import { match } from '@/utils/pattern-match-util'

export interface MappingRowProps {
  /**
   * The question's text; the question ID shows when it has none.
   */
  title: string
  questionId: string
  description: string
  type: MappingType
  isSelected?: boolean
  hasError?: boolean
  onPress?: () => unknown
  testId?: string
}

/**
 * A question of a template, with how the template answers it.
 */
export function MappingRow({
  title,
  questionId,
  description,
  type,
  isSelected,
  hasError,
  onPress,
  testId,
}: MappingRowProps) {
  return (
    <EditorListItem
      isSelected={isSelected}
      hasError={hasError}
      onPress={onPress}
      testId={testId}
    >
      <EditorListItemContent>
        <EditorListItemTitle isMuted={!title}>
          {title || questionId}
        </EditorListItemTitle>
        <EditorListItemDescription isMuted={!description}>
          {description || 'No description provided.'}
        </EditorListItemDescription>
      </EditorListItemContent>
      <EditorListBadge
        variant={match(type, { Manual: 'primary', Expr: 'secondary' })}
      >
        {match(type, { Manual: 'Manual', Expr: 'Expression' })}
      </EditorListBadge>
    </EditorListItem>
  )
}
